import { useEffect, useState } from "react";
import "./workspace.scss";
import { Col, Container, Row } from "react-bootstrap";

export interface IWorkspaceItem {
  type: "folder" | "video" | "image" | "document";
  text: string;
  date: string;
}

const WorkspacePage: React.FC = () => {
  const [workspaceData, setWorkspaceData] = useState<IWorkspaceItem[] | null>(
    null
  );

  let getWorkspaceDetails = (): IWorkspaceItem[] => {
    const workspaceInfo: { items: IWorkspaceItem[] } = {
      items: [
        { type: "folder", text: "Documents", date: "01/01/2025" },
        { type: "folder", text: "Policies", date: "01/01/2025" },
        { type: "document", text: "Message info", date: "01/01/2025" },
        { type: "image", text: "Poster updated", date: "01/01/2025" },
        { type: "video", text: "Prompotional video", date: "01/01/2025" },
      ],
    };

    return workspaceInfo.items;
  };

  // Constructor
  useEffect(() => {
    setWorkspaceData(getWorkspaceDetails());
  }, []);

  return (
    <section className="workspace-container-wrapper">
      <Container fluid>
        <Row>
          <Col lg={12} md={12} xs={12} className="wrokspace-wrapper">
            <div className="left-header">
              <span className="back"></span>
              <span className="header-text">Workspace</span>
            </div>

            <div className="right-header">
              <span className="search"></span>
              <span className="more"></span>
              <span className="upload">Upload</span>
            </div>
          </Col>
        </Row>
        <Row>
          {workspaceData?.map((item) => (
            <Col className="workspace-box">
              <div className="workspace-box__wrapper workspace-item">
                <span className="workspace-item__icon folder"></span>
                <span className="workspace-item__label">{item.text}</span>
                <span className="workspace-item__date">{item.date}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WorkspacePage;
